import { render, staticRenderFns } from "./ProductsFounders.vue?vue&type=template&id=aab768da&"
import script from "./ProductsFounders.vue?vue&type=script&lang=js&"
export * from "./ProductsFounders.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFounders.vue?vue&type=style&index=0&id=aab768da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsFoundersContainer: require('/app/appsumo/nuxt/components/products/founders/ProductsFoundersContainer.vue').default})
